<div class="col-lg-12">
    <label>{{'order.budget.project.destinationOrder' | translate}} *</label>
    <div ngbDropdown placement="bottom-left">
        <div>
            <form autocomplete="off">
                <input class="search-input form-control" type="text" name="quick-search" id="quick-search"
                    [placeholder]="'order.budget.project.orderSearch' | translate" [(ngModel)]="searchOrderValue"
                    (ngModelChange)="isLoadingOrder=true; orderResult=[]; selectedOrderIdentifier=undefined; this.orderSearch.next({ value: $event })">
            </form>
            <div *ngIf="isLoadingOrder && searchOrderValue.length > 0" class="ng-spinner-loader"></div>
            <div ngbDropdownMenu aria-labelledby="quick-search"
                [ngClass]="!orderSelected && searchOrderValue.length > 0 ? 'show' : ''" class="scrollable-menu"
                role="menu" placement="bottom-left" style="width: max-content;">
                <div ngbDropdownItem *ngFor="let res of orderResult">
                    <div class="menu-button" (click)="selectOrder(res)">
                        <div class="data-row" [innerHTML]="constructOrderDisplayName(res)">
                        </div>
                    </div>
                </div>
                <div *ngIf="orderResult.length === 0 && !isLoadingOrder && !orderSelected" ngbDropdownItem>
                    <div class="row menu-button">
                        {{'buttons.noResults' | translate}}
                    </div>
                </div>
            </div>
            <button class="btn closeSearch" (click)="closeOrderSearch()">
                <div [inlineSVG]="'assets/ico/clear-button.svg'" class="icon icon-black clear-search-icon" alt="clear">
                </div>
            </button>
        </div>
    </div>
</div>

<div class="col-lg-12 mt-4">
    <form [formGroup]="form" class="editForm" *ngIf="form">
    <label>{{'order.budget.project.destinationBudget' | translate}} *</label>
    <apc-form-select formControlName="destinationBudgetIdentifier" [items]="orderBudgets" [autogenerated]="disableBudgetSelect" [placeholder]="budgetPlaceholder" [class]="'budget-search'"
        [loading]="orderBudgetsLoading" [isObject]="true" [optionDescription]="['hoursAssigned', 'attachedTo']" optionName="budgetName" optionValue="budgetIdentifier">
    </apc-form-select>
    </form>
</div>

<div class="modal-footer p-0">
    <div class="container-fluid m-0 p-0">
        <button *ngIf="form" class="btn modal-btn save" [class.disabledButton]="!form.valid" [disabled]="!form.valid" (click)="migrate()">{{'buttons.migrateProject' | translate}}</button>
        <span class="btn modal-btn save back" (click)="cancel()">{{'buttons.back' | translate }}</span>
    </div>
</div>